import axios from "axios";
import {ApiError} from "./ApiError";
import {apiRequest, getHost} from "./ApiRequest";
import {filterSupportedCustodians} from "./Util";
import constants from "../constants";

const getPrice = params => {
    params.custodianId = params.custodianId || constants.custodianIds.coinbasePrime;
    return axios.get(
        getHost() + "/info/price",
        {
            params,
            timeout: 3000
        }
    ).then(response => {
        return Promise.resolve(response.data);
    }).catch(err => {
        return Promise.reject(new ApiError(err));
    });
};

const getMarket = params => {
    return axios.get(
        getHost() + "/info/market",
        {
            params
        }
    ).then(response => {
        return Promise.resolve(response.data);
    }).catch(err => {
        return Promise.reject(new ApiError(err));
    });
};

const getAlgorithms = () => {
    return axios.get(
        getHost() + "/info/algorithms",
    ).then(response => {
        return Promise.resolve(response.data);
    }).catch(err => {
        return Promise.reject(new ApiError(err));
    });
};

const getCustodians = () => {
    return apiRequest("get", "/custodians").then(response => {
        return Promise.resolve(filterSupportedCustodians(response.data));
    });
};

export {getPrice, getMarket, getAlgorithms, getCustodians};
